import * as React from 'react'
import { NavMain, NavMainItem } from '@/components/nav-main'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarInset,
  SidebarProvider,
  SidebarRail,
  SidebarTrigger
} from '@/components/sidebar'
import { Separator } from '@/components/separator'

export function SidebarLayout({
  ...props
}: React.ComponentProps<typeof Sidebar> & {
  navuser: React.ReactNode
  navorganisation: React.ReactNode
  navMainItems: NavMainItem[]
  breadcrumbs: React.ReactNode
  regions?: React.ReactNode
  sidebarFooterExtra?: React.ReactNode
  hideHeader?: boolean
  onNavigate: (url: string) => void
  version?: string
}) {
  return (
    <>
      <SidebarProvider>
        <Sidebar collapsible='icon'>
          <SidebarHeader>{props.navorganisation}</SidebarHeader>
          <SidebarContent>
            <NavMain
              items={props.navMainItems}
              groupTitle={'Organisation'}
              onNavigate={props.onNavigate}
            />
          </SidebarContent>
          <SidebarFooter>
            {props.sidebarFooterExtra}
            {props.navuser}
            {props.version && (
              <p className='text-muted-foreground px-2 pb-1 text-center text-xs group-data-[collapsible=icon]:hidden'>
                v{props.version}
              </p>
            )}
          </SidebarFooter>
          <SidebarRail />
        </Sidebar>
        <SidebarInset>
          {!props.hideHeader ? (
            <header className='flex h-16 shrink-0 items-center justify-between gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12'>
              <div className='flex items-center gap-2 px-4'>
                <SidebarTrigger className='-ml-1' />
                <Separator orientation='vertical' className='mr-2 h-4' />
                {props.breadcrumbs}
              </div>
              {props.regions && (
                <div className='flex items-center gap-2 px-4'>
                  {props.regions}
                </div>
              )}
            </header>
          ) : null}
          {props.children}
        </SidebarInset>
      </SidebarProvider>
    </>
  )
}
